// Роли пользователя из прав в токене
export enum UserJwtAuthority {
  SdkManager = 'ROLE_ROSASDKMANAGERGROUP',
  UserRegistered = 'ROLE_ROSAUSERREGISTEREDGROUP',
  Customer = 'ROLE_CUSTOMERGROUP',
}
